/**
 * Attendee Required Status used for find meeting times request
 */

enum AttendeeRequiredStatus {
    Required = 'required',
    Optional = 'optional',
}

export default AttendeeRequiredStatus;
